import _isMatch from 'lodash/isMatch';
import _merge from 'lodash/merge';
import { IBaseModel } from '../element-modeles/Interface/base/base-model.interface';

/**
 * 管理 model 中即将应用的数据变更
 */
export default class ModelModificationStash {
    private static instance: ModelModificationStash;
    public static getInstance() {
        if (!this.instance) {
            this.instance = new ModelModificationStash();
        }
        return this.instance;
    }

    // 当前已经暂存的 model 的数据改动
    private modificationMap: Map<string, Partial<IBaseModel>> = new Map();

    public hasModification(uiData: Partial<IBaseModel>, key: string) {
        const currentModelStashedData = this.modificationMap.get(key);
        if (!currentModelStashedData) {
            return false;
        }
        return _isMatch(currentModelStashedData, uiData);
    }

    public stashModification(uiData: Partial<IBaseModel>, key: string) {
        if (!this.modificationMap.has(key)) {
            this.modificationMap.set(key, {});
        }
        return _merge(this.modificationMap.get(key), uiData);
    }

    /**
     * 清除暂存的变更，在数据成功修改之后调用
     * @param key
     */
    public clearModification(key: string) {
        this.modificationMap.delete(key);
    }

    public getModifiedModelFromStash(model: IBaseModel) {
        const { key } = model;
        if (!this.modificationMap.has(key)) {
            return model;
        }
        return _merge({}, model, this.modificationMap.get(key));
    }
}
